"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseVersion = exports.isMaybeSupportedProtocolVersion = exports.LOCAL_PROTOCOL_VERSION = void 0;
exports.LOCAL_PROTOCOL_VERSION = '1.1';
/*
 * When two nodes negotiate whether they are compatible or not, it is up to the
 * newer version to decide if it supports the old version or not.
 *
 * The older version assumes optimistically that it may be supported by the newer
 * version. It can't know for sure, but the other node will tell if it is not
 * supported (e.g. rejecting the handshake with UNSUPPORTED_PROTOCOL_VERSION error).
 */
const isMaybeSupportedProtocolVersion = (remoteVersion) => {
    const localMajor = (0, exports.parseVersion)(exports.LOCAL_PROTOCOL_VERSION).major;
    const remoteMajor = (0, exports.parseVersion)(remoteVersion)?.major;
    if ((remoteMajor === undefined) || (remoteMajor < localMajor)) {
        return false;
    }
    else {
        // TODO implement proper checking when there are new protocol versions
        return true;
    }
};
exports.isMaybeSupportedProtocolVersion = isMaybeSupportedProtocolVersion;
const parseVersion = (version) => {
    const parts = version.split('.');
    if (parts.length === 2) {
        const values = parts.map((p) => Number(p));
        if (!values.some((v) => isNaN(v))) {
            return { major: values[0], minor: values[1] };
        }
    }
    else {
        return undefined;
    }
};
exports.parseVersion = parseVersion;
//# sourceMappingURL=version.js.map